export const INACTIVITY_COUNTDOWN_SEC = 10
export const INACTIVITY_TIMEOUT_SEC = 120
